import { IntegrationType } from "@speaker/database"
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { z } from "zod"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function stringTransformer(item: any) {
  const nullValues = ["", undefined, null]
  if (nullValues.includes(item)) return null
  return String(item)
}
export const zStringNull = z.any().transform(stringTransformer)

function numberTransformer(item: any) {
  const nullValues = ["", undefined, null]
  if (nullValues.includes(item)) return null
  return Number(item)
}
export const zNumberNull = z
  .any()
  .transform(numberTransformer)
  .refine((item) => !isNaN(Number(item)), "Not a valid number")

export const integrationTypeToInfo: Record<
  IntegrationType,
  {
    icon: string
    name: string
    url: string
  }
> = {
  Alexa: {
    icon: "/alexa.svg",
    name: "Alexa",
    url: "https://google.com",
  },
  // Google: {
  //   icon: "/alexa.svg",
  //   name: "Amazon Alexa",
  //   url: "https://google.com",
  // },
}
